import { render } from "./TheSidebar.vue?vue&type=template&id=a59c5b10&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "./TheSidebar.vue?vue&type=style&index=0&id=a59c5b10&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59c5b10"]])

export default __exports__